import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "_mb-6 gfu-bt--b1" }
const _hoisted_2 = { class: "_pa-2" }
const _hoisted_3 = ["href"]
const _hoisted_4 = ["href"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_title = _resolveComponent("base-title")
  const _component_themed_image = _resolveComponent("themed-image")
  const _component_base_compare_row = _resolveComponent("base-compare-row")
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_base_compare_table = _resolveComponent("base-compare-table")
  const _component_box = _resolveComponent("box")

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_base_title, {
      as: "h3",
      level: "h2"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.Resources.PledgeManager.SectionComparisonTitle), 1 /* TEXT */)
      ]),
      _: 1 /* STABLE */
    }),
    _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.Resources.PledgeManager.SectionComparisonDescription), 1 /* TEXT */),
    _createVNode(_component_box, {
      content: "",
      class: "_ov-h"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_base_compare_table, {
            "primary-label": $options.platformName,
            "secondary-label": "Kickstarter"
          }, {
            default: _withCtx(() => [
              (!$options.isMobile)
                ? (_openBlock(), _createBlock(_component_base_compare_row, {
                    key: 0,
                    highlighted: "none"
                  }, {
                    primary: _withCtx(() => [
                      _createVNode(_component_themed_image, {
                        src: "/content/images/static/logo/site-logo.svg",
                        height: "20",
                        alt: $options.platformName
                      }, null, 8 /* PROPS */, ["alt"])
                    ]),
                    secondary: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                      _createElementVNode("strong", null, "Kickstarter", -1 /* CACHED */)
                    ]))]),
                    _: 1 /* STABLE */
                  }))
                : _createCommentVNode("v-if", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.rows, (row, index) => {
                return (_openBlock(), _createBlock(_component_base_compare_row, {
                  key: row.label,
                  first: index === 0,
                  last: index === $props.rows.length - 1,
                  highlighted: row.highlight
                }, {
                  label: _withCtx(() => [
                    (row.labelLinkUrl)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          href: row.labelLinkUrl,
                          class: "_tdu",
                          target: "_blank",
                          rel: "noopener noreferrer"
                        }, _toDisplayString(row.label), 9 /* TEXT, PROPS */, _hoisted_3))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(_toDisplayString(row.label), 1 /* TEXT */)
                        ], 64 /* STABLE_FRAGMENT */))
                  ]),
                  primary: _withCtx(() => [
                    (row.primaryIcon)
                      ? (_openBlock(), _createBlock(_component_base_icon, {
                          key: 0,
                          name: row.primaryIcon,
                          size: "lg",
                          class: "_tc--accent"
                        }, null, 8 /* PROPS */, ["name"]))
                      : (row.primaryLinkUrl)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 1,
                            href: row.primaryLinkUrl,
                            class: "_tdu",
                            target: "_blank",
                            rel: "noopener noreferrer"
                          }, _toDisplayString(row.primary), 9 /* TEXT, PROPS */, _hoisted_4))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                            _createTextVNode(_toDisplayString(row.primary), 1 /* TEXT */)
                          ], 64 /* STABLE_FRAGMENT */))
                  ]),
                  secondary: _withCtx(() => [
                    (row.secondaryIcon)
                      ? (_openBlock(), _createBlock(_component_base_icon, {
                          key: 0,
                          name: row.secondaryIcon,
                          size: "lg"
                        }, null, 8 /* PROPS */, ["name"]))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(_toDisplayString(row.secondary), 1 /* TEXT */)
                        ], 64 /* STABLE_FRAGMENT */))
                  ]),
                  _: 2 /* DYNAMIC */
                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["first", "last", "highlighted"]))
              }), 128 /* KEYED_FRAGMENT */))
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["primary-label"])
        ])
      ]),
      _: 1 /* STABLE */
    })
  ]))
}